import type { PagesResponse, TransactionStatus } from '@/lib/heyapi/types.gen';

type StepState = 'completed' | 'current' | 'pending';

interface Steps {
  id: number;
  title: string;
  key?: keyof PagesResponse;
}

export const newGradSteps: Steps[] = [
  { id: 1, title: 'Your Information', key: 'yourInformation' },
  { id: 2, title: 'Coverage Questions', key: 'coverageQuestions' },
  { id: 3, title: 'Summary', key: 'summary' },
  { id: 4, title: 'Representations And Fraud', key: 'representationsAndFraud' },
  { id: 5, title: 'Pay & Issue Coverage', key: 'payment' },
];

export const isStepCompleted = (
  step: number,
  pages: PagesResponse | undefined
): boolean => {
  const stepKey = newGradSteps[step - 1]?.key;

  if (stepKey === 'payment') {
    return Boolean(pages?.payment?.paymentData?.paidAt);
  }

  if (pages && stepKey && pages[stepKey]) {
    return true;
  }

  return false;
};

export const getStepState = (step: number, currentStep: number): StepState => {
  if (step === currentStep) return 'current';

  return 'pending';
};

export const getCurrentAndNextStep = (currentStep: number, steps: Steps[]) => {
  if (currentStep > steps.length)
    return { currStep: steps[steps.length - 1], nextStep: null };
  const currStep = steps.find((step) => step.id === currentStep);
  const nextStep = steps.find((step) => step.id === currentStep + 1);
  return { currStep, nextStep };
};

const stepStyles: Record<StepState, { circle: string; text: string }> = {
  completed: {
    circle: 'text-white',
    text: 'text-brand-700 text-base',
  },
  current: {
    circle: 'bg-brand-green text-white font-bold',
    text: 'text-brand-700 font-medium text-base',
  },
  pending: {
    circle: 'border border-[#868688] text-[#868688]',
    text: 'text-[#868688] text-base',
  },
};

export const getStepStyles = (stepState: StepState, isCompleted: boolean) => {
  if (stepState === 'current') {
    return {
      circle: stepStyles.current.circle,
      text: stepStyles.current.text,
    };
  }

  if (isCompleted) {
    return {
      circle: stepStyles.completed.circle,
      text: stepStyles.completed.text,
    };
  }

  return {
    circle: stepStyles.pending.circle,
    text: stepStyles.pending.text,
  };
};

export const statusToLabel: Record<TransactionStatus, string> = {
  in_progress: 'In Progress',
  active: 'Policy Bound',
  expired: 'Expired',
  declined: 'Declined',
  cancelled: 'Cancelled',
  pending_reversion: 'Pending Reversion',
  reverted: 'Reverted',
  discarded: 'Discarded',
  not_taken: 'Not Taken',
};
